import {hitGoogleTagManager} from "./init_google_tag_manager";

type Action = "credit_form_open" | "credit_bank_offers" | "next_step";

export const gtmEventCreditCalculator = (action: Action) => {
    const gtmData = {
        event: "credit_calculator",
        credit_action: action
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./init_google_tag_manager";

type Action = "credit_form_open" | "credit_bank_offers" | "next_step";

export const gtmEventCreditCalculator = (action: Action) => {
    const gtmData = {
        event: "credit_calculator",
        credit_action: action
    };

    hitGoogleTagManager(gtmData);
};
